module.exports = __webpack_public_path__ + "img/1-1.d571d55b.png";